<div class="tw-grid tw-grid-cols-12">
    <div
        class="tw-border-r-1 tw-col-span-1 tw-border-l-0 tw-border-t-0 tw-border-b-0 tw-border-solid tw-border-gray-300"></div>
    <div class="tw-col-span-12 tw-grid tw-grid-cols-12">
        <div class="tw-col-span-1"></div>
        <div
            class="tw-col-span-1 tw-break-all tw-bg-gray-100 tw-pr-5 tw-pt-2"></div>
        <div class="tw-col-span-1 tw-break-all tw-bg-gray-100 tw-pr-5 tw-pt-2">
            <span class="bold">{{
                'OUTGOING-GOODS.DELIVERY-NOTE-LIST-VIEW.TABLE-HEADER.DELIVERY-NO'
                    | translate
            }}</span>
        </div>
        <div class="tw-col-span-1 tw-break-all tw-bg-gray-100 tw-pr-5 tw-pt-2">
            <span class="bold">{{
                'OUTGOING-GOODS.FOLDER-VIEW.TABLE-HEADER.ORDER-NO' | translate
            }}</span>
        </div>
        <div class="tw-col-span-1 tw-break-all tw-bg-gray-100 tw-pr-5 tw-pt-2">
            <span class="bold">{{
                'OUTGOING-GOODS.FOLDER-VIEW.TABLE-HEADER.REFERENCE-NO'
                    | translate
            }}</span>
        </div>
        <div class="tw-col-span-1 tw-break-all tw-bg-gray-100 tw-pr-5 tw-pt-2">
            <span class="bold">{{
                'OUTGOING-GOODS.FOLDER-VIEW.TABLE-HEADER.ADVISED-DATE'
                    | translate
            }}</span>
        </div>
        <div class="tw-col-span-1 tw-break-all tw-bg-gray-100 tw-pr-5 tw-pt-2">
            <span class="bold">{{
                'OUTGOING-GOODS.FOLDER-VIEW.TABLE-HEADER.RECEIVE-DATE'
                    | translate
            }}</span>
        </div>
        <div class="tw-col-span-1 tw-break-all tw-bg-gray-100 tw-pr-5 tw-pt-2">
            <span class="bold">{{
                'OUTGOING-GOODS.FOLDER-VIEW.TABLE-HEADER.STATE' | translate
            }}</span>
        </div>
        <div class="tw-col-span-1 tw-break-all tw-bg-gray-100 tw-pr-5 tw-pt-2">
            <span class="bold">{{
                'OUTGOING-GOODS.DELIVERY-NOTE-LIST-VIEW.TABLE-HEADER.DISCREPANCIES'
                    | translate
            }}</span>
        </div>
        <div class="tw-col-span-1 tw-break-all tw-bg-gray-100 tw-pr-5 tw-pt-2">
            <span class="bold">{{
                'OUTGOING-GOODS.DELIVERY-NOTE-LIST-VIEW.TABLE-HEADER.PALLET-TICKET'
                    | translate
            }}</span>
        </div>
        <div class="tw-col-span-1 tw-break-all tw-bg-gray-100 tw-pr-5 tw-pt-2">
            <span class="bold">
                {{ 'GLOBAL.ORIGINAL_CONSIGNOR' | translate }}</span
            >
        </div>
        <div
            class="tw-col-span-1 tw-break-all tw-bg-gray-100 tw-pr-5 tw-pt-2 tw-w-[110px]">
            <span class="bold"> {{ 'GLOBAL.GLN' | translate }}</span>
        </div>
    </div>
</div>
@for (deliveryNote of tour()?.deliveryNotes; track deliveryNote._key; let i = $index) {
    <div class="tw-grid tw-grid-cols-12">
        <div
            class="tw-border-r-1 tw-col-span-1 tw-border-l-0 tw-border-t-0 tw-border-b-0 tw-border-solid tw-border-gray-300"></div>
        <div class="tw-col-span-12 tw-grid tw-grid-cols-12">
            <div class="tw-col-span-1 tw-grid tw-grid-rows-2 tw-pt-2">
                <div></div>
                <div
                    class="tw-border-t-1 tw-border-l-0 tw-border-r-0 tw-border-b-0 tw-border-solid tw-border-gray-300"></div>
            </div>
            <div
                class="tw-col-span-1 tw-flex tw-flex-row tw-justify-start tw-bg-gray-100 tw-pr-5 tw-pt-2">
                <div class="placer">
                    <button
                        mat-icon-button
                        matTooltip="{{
                            'OUTGOING-GOODS.FOLDER-VIEW.HOVER-TEXT.VIEW-DELIVERY-NOTE'
                                | translate
                        }}"
                        id="view-deliveryNote-button"
                        (click)="viewDeliveryNote(deliveryNote)">
                        <mat-icon fontSet="material-symbols-outlined"
                            >visibility</mat-icon
                        >
                    </button>
                </div>
                <div class="placer">
                    <app-download-note-button
                        [organizationSiteKey]="organizationSiteKey()"
                        [deliveryNote]="deliveryNote"
                        [fetchCompletePDF]="
                            tour()?.status !== 'open' ? true : false
                        "
                        [orgType]="orgType()"></app-download-note-button>
                </div>
                <div class="placer">
                    @if (
                        deliveryNote.dateReceived && isConsignee && !readOnly()
                    ) {
                        <button
                            mat-icon-button
                            matTooltip="{{
                                'OUTGOING-GOODS.FOLDER-VIEW.HOVER-TEXT.ADD-DELIVERY-NOTE-APPENDIX'
                                    | translate
                            }}"
                            id="add-appendix-note-button"
                            class="fine-discre-button"
                            [disabled]="deliveryNote.fineDiscrepancies"
                            (click)="
                                deliveryNoteKeyForFineDiscrepancyUpload =
                                    deliveryNote._key;
                                fineDiscrepancyFileInput.click()
                            ">
                            <mat-icon svgIcon="add-deviations"></mat-icon>
                        </button>
                    }
                </div>
                <div class="placer">
                    @if (
                        !isConsignee && tour()?.status !== 'closed' && !readOnly()
                    ) {
                        <button
                            mat-icon-button
                            matTooltip="{{
                                'SPEDITEUR.TABLE.HOVER-TEXT.UNBIND-DELIVERYNOTE-FROM-TOUR'
                                    | translate
                            }}"
                            id="delete-note-button"
                            (click)="deleteDeliveryNote(deliveryNote._key)">
                            <mat-icon fontSet="material-symbols-outlined"
                                >cut</mat-icon
                            >
                        </button>
                    }
                </div>
            </div>
            <div
                class="tw-col-span-1 tw-flex tw-flex-col tw-justify-center tw-bg-gray-100 tw-pr-5 tw-pt-2">
                <span [matTooltip]="deliveryNote.number || ''">{{
                    deliveryNote.number
                }}</span>
            </div>
            <div
                class="tw-col-span-1 tw-flex tw-flex-col tw-justify-center tw-bg-gray-100 tw-pr-5 tw-pt-2">
                <span class="truncate">{{ deliveryNote.orderNumber }}</span>
            </div>
            @if (orgType() === 'consignee' || deliveryNote.dateReceived) {
                <div
                    class="tw-col-span-1 tw-flex tw-flex-col tw-justify-center tw-bg-gray-100 tw-pr-5 tw-pt-2">
                    <span class="truncate">{{
                        deliveryNote.properties?.referenceNumber
                    }}</span>
                </div>
            }
            @if (!(orgType() === 'consignee' || deliveryNote.dateReceived)) {
                <div
                    class="tw-col-span-1 tw-flex tw-flex-col tw-justify-center tw-bg-gray-100 tw-pr-5 tw-pt-2">
                    <!-- Display mode -->
                    @if (!isNoteInEditMode(deliveryNote)) {
                        <!-- With existing reference -->
                        @if (deliveryNote.properties?.referenceNumber) {
                            <div
                                class="tw-cursor-pointer"
                                (click)="openEditNoteReference(deliveryNote)"
                                [matTooltip]="
                                    'OUTGOING-GOODS.FOLDER-VIEW.HOVER-TEXT.EDIT-REFERENCE-NAME'
                                        | translate
                                ">
                                {{ deliveryNote.properties?.referenceNumber }}
                            </div>
                        }
                        <!-- No reference yet -->
                        @if (!deliveryNote.properties?.referenceNumber) {
                            <div
                                class="tw-flex tw-cursor-pointer tw-flex-row tw-items-center !tw-font-normal tw-italic"
                                (click)="openEditNoteReference(deliveryNote)"
                                [matTooltip]="
                                    'OUTGOING-GOODS.FOLDER-VIEW.HOVER-TEXT.EDIT-REFERENCE-NUMBER'
                                        | translate
                                ">
                                <span class="tw-mr-1.5">{{
                                    'OUTGOING-GOODS.FOLDER-VIEW.REFERENCE'
                                        | translate
                                }}</span>
                                <span
                                    class="material-symbols-outlined tw-text-xl"
                                    >edit</span
                                >
                            </div>
                        }
                    }
                    <!-- Edit mode -->
                    @if (isNoteInEditMode(deliveryNote)) {
                        <div class="tw-flex tw-items-center">
                            <input
                                aria-label="reference-number-input"
                                [ngStyle]="{
                                    'width.ch':
                                        (deliveryNote.properties
                                            ?.referenceNumber?.length || 0) + 2,
                                    'min-width.ch': 4,
                                }"
                                #inputRefText
                                minlength="4"
                                [(ngModel)]="
                                    deliveryNote.properties!.referenceNumber
                                "
                                (keydown.enter)="
                                    editNoteReference(deliveryNote)
                                " />
                            <div class="tw-flex">
                                <button
                                    aria-label="save-reference-number"
                                    (click)="editNoteReference(deliveryNote)"
                                    mat-icon-button>
                                    <mat-icon
                                        fontSet="material-symbols-outlined"
                                        >save</mat-icon
                                    >
                                </button>
                                <button
                                    (click)="
                                        resetEditNoteReference(deliveryNote)
                                    "
                                    mat-icon-button>
                                    <mat-icon
                                        fontSet="material-symbols-outlined"
                                        >cancel</mat-icon
                                    >
                                </button>
                            </div>
                        </div>
                    }
                </div>
            }
            <div
                class="tw-col-span-1 tw-flex tw-flex-col tw-justify-center tw-bg-gray-100 tw-pr-5 tw-pt-2">
                @if (deliveryNote.dateAnnounced) {
                    <span>{{
                        deliveryNote.dateAnnounced
                            | date: undefined : currentLanguageCode
                    }}</span>
                }
            </div>
            <div
                class="tw-col-span-1 tw-flex tw-flex-col tw-justify-center tw-bg-gray-100 tw-pr-5 tw-pt-2">
                @if (deliveryNote.dateReceived) {
                    <span>{{
                        deliveryNote.dateReceived
                            | date: undefined : currentLanguageCode
                    }}</span>
                }
            </div>
            <div
                class="tw-col-span-1 tw-flex tw-flex-col tw-justify-center tw-bg-gray-100 tw-pr-5 tw-pt-2">
                @if (deliveryNote.dateReceived) {
                    <span>
                        {{
                            'OUTGOING-GOODS.DELIVERY-NOTE-BUNDLE.STATUS.CLOSED'
                                | uppercase
                                | translate
                        }}</span
                    >
                }
                @if (!deliveryNote.dateReceived) {
                    <span>
                        {{
                            'OUTGOING-GOODS.DELIVERY-NOTE-BUNDLE.STATUS.SENT'
                                | uppercase
                                | translate
                        }}</span
                    >
                }
            </div>
            <div
                class="tw-col-span-1 tw-flex tw-flex-col tw-justify-center tw-bg-gray-100 tw-pr-5 tw-pt-2">
                @if (
                    deliveryNote.discrepancies || deliveryNote.fineDiscrepancies
                ) {
                    <div
                        class="tw-flex tw-h-auto tw-flex-row tw-justify-start tw-align-middle">
                        @if (deliveryNote.discrepancies) {
                            <div class="tw-leading-6">
                                {{
                                    'OUTGOING-GOODS.DELIVERY-NOTE-LIST-VIEW.ROUGH-CONTROL'
                                        | translate
                                }}
                            </div>
                        }
                        @if (
                            deliveryNote.discrepancies &&
                            deliveryNote.fineDiscrepancies
                        ) {
                            <div class="tw-mx-1 tw-leading-6">|</div>
                        }
                        @if (deliveryNote.fineDiscrepancies) {
                            <div class="tw-leading-6">
                                {{
                                    'OUTGOING-GOODS.DELIVERY-NOTE-LIST-VIEW.FINIT-CONTROL'
                                        | translate
                                }}
                            </div>
                        }
                        <mat-icon
                            class="tw-ml-3"
                            svgIcon="red-error"></mat-icon>
                    </div>
                }
                @if (
                    !deliveryNote.discrepancies &&
                    !deliveryNote.fineDiscrepancies
                ) {
                    <div>-</div>
                }
            </div>
            <div
                class="tw-col-span-1 tw-flex tw-flex-col tw-justify-center tw-bg-gray-100 tw-pr-5 tw-pt-2">
                @if (deliveryNote.palletTickets) {
                    <img
                        matTooltip="{{
                            'OUTGOING-GOODS.FOLDER-VIEW.HAS-PALLETTICKET'
                                | translate
                        }}"
                        src="assets/images/load_carrier_icon.svg"
                        alt="exists"
                        width="23"
                        height="23" />
                }
            </div>
            <div
                class="tw-col-span-1 tw-flex tw-flex-col tw-justify-center tw-bg-gray-100 tw-pr-5 tw-pt-2">
                <span>{{ deliveryNote.originalConsignor }}</span>
            </div>
            <div
                class="tw-col-span-1 tw-flex tw-flex-col tw-justify-center tw-bg-gray-100 tw-pr-5 tw-pt-2 tw-w-[110px]">
                <span>{{ deliveryNote.originalConsignorGln }}</span>
            </div>
        </div>
    </div>
}
<input
    class="d-none"
    multiple
    #fineDiscrepancyFileInput
    type="file"
    accept=".pdf"
    (change)="selectFineDiscrepancyFile($event)" />
